export default function recaptcha(publicKey) {
  return new Promise((resolve, reject) => {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(publicKey, { action: 'submit' })
        .then(function (token) {
          resolve(token);
        })
        .catch((err) => reject(err));
    });
  });
}

function findRecaptchaHook(scopeSelector) {
  return $(scopeSelector).find('.g-recaptcha-response-hook');
}

function isFormUsingHTMX(event) {
  return (
    event.target.matches('.replaceable') &&
    event.target.classList.contains('replaceable')
  );
}

export function getPublicKeyOfScope(scopeSelector) {
  return findRecaptchaHook(scopeSelector).data('sitekey');
}

export function initializeRecaptcha() {
  findRecaptchaHook(document).each(function () {
    const publicKey = $(this).data('sitekey');

    this.closest('form').addEventListener('submit', (e) => {
      e.preventDefault();
      recaptcha(publicKey).then((token) => {
        this.value = token;
        if (isFormUsingHTMX(e)) {
          const event = new Event('HTMX:recaptcha-verified');
          e.target.dispatchEvent(event);
        } else {
          e.target.submit();
        }
      });

      return false;
    });
  });
}
